import React from "react";
import "./Footer.css";
import najeeb from "../../Assets/najeeb.jpg"
import { NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <div className="contsec">
        <h1>Start a project</h1>
        <h3>
          Interested in working together? We should queue up a time to chat.
        </h3>
        <div className="buton">
          <a href="mailto:najeebu50@gmail.com" className="btnss">
            <p> Let's Do It </p>
          </a>
        </div>
      </div>
      <div className="foomain">
      <div className="foosub">
      <img src={najeeb} alt="Mohd Najeeb Ullah" style={{ width: "20%" }} />
        <h2>Living, learning, & leveling up<br></br> one day at a time.</h2>
        <p>Handcrafted by me © 2022-30</p>

        </div>
      </div>
    </>
  );
};

export default Footer;
